import { useCallback } from 'react';
import { ToastSeverity } from '../constants/toast';
import { toastActions } from './toastSlice';
import { useAppDispatch } from './hooks';

/** Returns toast action dispatchers so components can show or close Redux-managed notifications. */
export const useToastActions = () => {
  const dispatch = useAppDispatch();

  /** Shows a toast with optional severity through the shared Redux toast slice. */
  const showToast = useCallback((message: string, severity?: ToastSeverity) => {
    dispatch(toastActions.showToast({ message, severity }));
  }, [dispatch]);

  /** Closes the currently visible toast in the shared Redux toast slice. */
  const closeToast = useCallback(() => {
    dispatch(toastActions.closeToast());
  }, [dispatch]);

  return { showToast, closeToast };
};
